import { camelCaseFormat } from './camelCaseFormat';

export function tagIdToText(tagId, tags, camelCase = true) {
  if (!tags) {
    return;
  }

  let foundTag = _.find(tags, function(tag) {
    return !tag ? false : tag.tagType + ':' + tag.tagName === tagId;
  });

  if (!foundTag) {
    const parts = tagId.split(':');
    let text = '';
    parts.forEach(p => {
      text += (camelCase ? camelCaseFormat(p) : p) + ' - ';
    });

    if (text.length > 0) {
      return text.slice(0, -3);
    }

    return text;
  }

  return (
    camelCaseFormat(foundTag.tagSource) +
    ' - ' +
    camelCaseFormat(foundTag.tagType) +
    ' - ' +
    (foundTag.displayName || camelCaseFormat(foundTag.tagName))
  );
}
